export default __webpack_public_path__ + "static/media/Arbeidsnotat prosjekt med NArFU.fd97be10.pdf";